import {InfluencerIgStoryLoadingStatus, InfluencerPost} from './influencer';
import {DiscoverPost} from './discover';

export class InfluencerIgNewStory {
  public id: string;
  public influencerId: number;
  public status: InfluencerIgStoryLoadingStatus;
  public progress: number;
  public newIgStories: Array<DiscoverPost>;
}



// WEBPACK FOOTER //
// ./src/models/influencer-ig-new-story.ts